import { useTranslation } from 'react-i18next';

function labelBp(type: string) {
  const { t } = useTranslation();
  const label: { [val: string]: string } = {
    'primary': t('biz_process.table.c_primary'),
    'steering': t('biz_process.table.c_steering'),
    'support': t('biz_process.table.c_support')
  };

  return label[type];
}

export default labelBp;
